export const getFeatureProgressItemStyles = () => ({
  itemContainer: {
    marginBottom: '37px',
  },
  itemTitle: {
    border: '0',
    background: '#FFFFFF',
    fontSize: '28px',
    fontWeight: 600,
    padding: '0px',
    lineHeight: '36px',
    textAlign: 'left',
  },
  'itemTitle-s': {
    fontSize: '24px',
  },
  itemDescription: {
    fontSize: '20px',
    lineHeight: '28px',
    marginTop: '16px',
    color: '#424242',
  },
  itemProgressBar: {
    margin: '37px 0px 20px 0px',
  },
});
